// extracted by mini-css-extract-plugin
export default {"zoomModal":"s1-z","image":"t1-z","button":"u1-z","isOverlayShown":"v1-z"};